// Flexibele lesopbouw (build 2.6).
//
// Kleuren: het serviceblok is lichtblauw; de extra oefening krijgt de kleur van het
// plan (rood, oranje, ...) als de les dat niveau meekrijgt (lessonBlocks(les, lv)).
//
// Een les blijft een object met per blok de oefening-gegevens (zoals altijd:
// { warmup: {...}, exercise1: {...}, exercise2: {...}, match: {...} }). Nieuw is de
// optionele lijst `order` met de sleutels in de gekozen volgorde, bv.
//   ["warmup", "service1", "exercise1", "exercise2", "exercise3", "extra", "match"]
// Zonder `order` geldt de oude vaste opbouw, dus bestaande lessen (ook het archief)
// werken zonder omzetten. Het type van een blok volgt uit de sleutel (cijfers eraf):
// warmup, exercise, service, extra, match.

export var DEFAULT_ORDER = ["warmup", "exercise1", "exercise2", "match"];

export var BTYPES = {
  warmup:   { icon: "W", bg: "#1D7F8C", fg: "#fff", ink: "#1D7F8C", label: "Warming-up", tint: null, time: 10 },
  exercise: { icon: "1", bg: "#C4552F", fg: "#fff", ink: "#C4552F", label: "Oefening", tint: null, time: 10 },
  service:  { icon: "S", bg: "#6CB8E6", fg: "#0E3A5C", ink: "#1F6FA5", label: "Serviceblok", tint: "#EAF5FC", time: 5 },
  extra:    { icon: "E", bg: "#6A4BB0", fg: "#fff", ink: "#6A4BB0", label: "Extra oefening", tint: "#F2EEFA", time: 10 },
  match:    { icon: "⚡", bg: "#1A2744", fg: "#fff", ink: "#1A2744", label: "Wedstrijdvorm", tint: null, time: 20 },
};

export function blockType(key) {
  var t = String(key || "").replace(/\d+$/, "");
  return BTYPES[t] ? t : "exercise";
}

export function lessonOrder(les) {
  var o = les && Array.isArray(les.order) && les.order.length ? les.order : DEFAULT_ORDER;
  return o.filter(function (k, i) { return typeof k === "string" && o.indexOf(k) === i; });
}

// De blokken van een les, met weergave-info. Oefeningen worden doorgenummerd op
// volgorde (de sleutel exercise2 kan dus "Oefening 1" heten als er een weg is).
export function lessonBlocks(les, lv) {
  var n = 0;
  return lessonOrder(les).map(function (key) {
    var type = blockType(key);
    var def = BTYPES[type];
    var b = { key: key, type: type, icon: def.icon, bg: def.bg, fg: def.fg, ink: def.ink, tint: def.tint, label: def.label };
    if (type === "exercise") { n += 1; b.icon = String(n); b.label = "Oefening " + n; }
    if (type === "extra" && lv && lv.color) { b.bg = lv.color; b.fg = lv.on || "#fff"; b.ink = lv.ink || lv.color; b.tint = lv.bg || b.tint; }
    b.data = (les && les[key]) || { description: "", accents: [], time: def.time };
    return b;
  });
}

export function blocksMinutes(les) {
  return lessonBlocks(les).reduce(function (s, b) { return s + (Number(b.data.time) || 0); }, 0);
}

// Nieuwe unieke sleutel voor een type (exercise3, service2, ...).
export function newKey(type, les, order) {
  if (type === "warmup" || type === "match" || type === "extra") return type;
  var used = {};
  Object.keys(les || {}).forEach(function (k) { used[k] = true; });
  (order || []).forEach(function (k) { used[k] = true; });
  for (var i = 1; i < 999; i++) { if (!used[type + i]) return type + i; }
  return type + Date.now();
}

// Regels: warming-up altijd eerst, wedstrijdvorm altijd laatst. Alles daartussen
// (oefeningen, serviceblokken, extra oefening) is vrij te schuiven, dus een serviceblok
// staat nooit vóór de warming-up of na de wedstrijdvorm.
export function normalizeOrder(order) {
  var mid = order.filter(function (k) { var t = blockType(k); return t !== "warmup" && t !== "match"; });
  return ["warmup"].concat(mid, ["match"]);
}

// Halve minuten (build 2.6): tijden worden opgeslagen als getal (7.5) en getoond als
// 7′30″. Met style "min" krijgen hele minuten "min" erachter (10 min), anders 10′.
export function fmtDur(n, style) {
  var v = Math.round((Number(n) || 0) * 2) / 2;
  var m = Math.floor(v), half = v - m >= 0.5;
  if (half) return m + "′30″";
  return style === "min" ? m + " min" : m + "′";
}
// Leest "7:30", "7'30", "7′30″", "7,5", "7.5" of "7"; rondt af op een halve minuut.
// Geeft null bij onzin.
export function parseDur(s) {
  var t = String(s == null ? "" : s).trim().replace(/[″"]/g, "").replace(/\s+/g, "");
  if (!t) return null;
  var m = t.match(/^(\d{1,3})(?:([:'′])(\d{0,2})|([,.])(\d*))?′?$/);
  if (!m) return null;
  var v = parseInt(m[1], 10);
  if (m[2] && m[3]) v += parseInt(m[3], 10) / 60;
  if (m[4] && m[5]) v += parseFloat("0." + m[5]);
  return Math.min(180, Math.round(v * 2) / 2);
}
